<template>
  <canvas
    ref="canvas"
    width="8"
    height="8"
    class="image-pixelated"
    :title="altText"
  />
</template>

<script>
  export default {
    name: 'PlayerAvatar',

    props: {
      textureId: {
        type: String,
        default: '',
      },
      playerName: {
        type: [String, Array],
        default: '',
      },
    },

    computed: {
      parsedPlayerName () {
        if (!this.playerName) return ''
        return typeof this.playerName === 'string'
          ? this.playerName
          : this.playerName[0] || ''
      },

      altText () {
        return this.parsedPlayerName ? `${this.parsedPlayerName}'s avatar` : null
      },
    },

    watch: {
      textureId (newId) {
        this.drawAvatar(newId)
      },
    },

    mounted () {
      if (this.textureId) {
        this.drawAvatar(this.textureId)
      }
    },

    methods: {
      drawAvatar (id) {
        const canvas = this.$refs.canvas
        if (!canvas) return
        const ctx = canvas.getContext('2d')

        ctx.clearRect(0, 0, 8, 8)
        if (!id) return

        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.src = `https://textures.minecraft.net/texture/${id}`

        img.onload = () => {
          if (!this.$refs.canvas) return
          ctx.imageSmoothingEnabled = false
          ctx.clearRect(0, 0, 8, 8)

          // (8,8,8,8) -> (0,0,8,8)
          ctx.drawImage(img, 8, 8, 8, 8, 0, 0, 8, 8)
          // (40,8,8,8) -> (0,0,8,8)
          ctx.drawImage(img, 40, 8, 8, 8, 0, 0, 8, 8)
        }

        img.onerror = (err) => {
          console.error(`[PlayerAvatar] Failed to load texture: ${id}`, err)
        }
      },
    },
  }
</script>